var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconShow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.25 3C3.25 3 1 9 1 9C1 9 3.25 15 9.25 15C15.25 15 17.5 9 17.5 9C17.5 9 15.25 3 9.25 3ZM9.25 4.5C13.207 4.5 15.2084 7.70032 15.8564 8.99707C15.2077 10.2848 13.1912 13.5 9.25 13.5C5.293 13.5 3.29155 10.2997 2.64355 9.00293C3.29305 7.71518 5.30875 4.5 9.25 4.5ZM9.25 6C7.59325 6 6.25 7.34325 6.25 9C6.25 10.6568 7.59325 12 9.25 12C10.9067 12 12.25 10.6568 12.25 9C12.25 7.34325 10.9067 6 9.25 6Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconShow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "7b7ade76e98dd4ada2ea8cd4c8381f30.svg";